
export class MSToast {
    constructor(param) {
        this.parent = param.parent;
        this.toast = param.toast;
        this.toast_header = param.header;
        this.toast_body = param.body;
        this.timeout = param.timeout;
    }

    create() {
        console.warn('create is obsolete, please use $create instead');
        return this.$create()
    }


    $create() {
        if($(".toast-container").length<=0){
            var $container = $("<div/>").addClass("toast-container position-absolute top-0 end-0 p-1 w-100").appendTo($("html"));
            this.parent = $container;
        }
        var $toast=$("<div/>").addClass(this.toast.class).attr({"id":this.toast.attr.id, "role":this.toast.attr.role, "aria-live":this.toast.attr["aria-live"], "aria-atomic":this.toast.attr["aria-atomic"]}).appendTo(this.parent);
            if(this.toast_header){
                var $header=$("<div/>").addClass(this.toast_header.class).appendTo($toast);
                    if(this.toast_header.img){
                        var $img=$("<img/>").addClass(this.toast_header.img.class).attr({"src":this.toast_header.img.src, "height":this.toast_header.img.height, "width":this.toast_header.img.width}).appendTo($header);
                    }
                    
                    var $time=$("<small/>").addClass("ms-auto").text(moment().format("HH")+"h"+moment().format("mm")).appendTo($header);
                    var $btn_close=$("<button/>").addClass("btn-close p-0").attr({"type":"button", "data-bs-dismiss":"toast", "data-bs-target":"#toast_prog", "aria-label":"Close"}).appendTo($header).on("click",() => {
                        $toast.remove();
                    })
            }
            if(this.toast_body){
                var $body=$("<div/>").addClass(this.toast_body.class).appendTo($toast);
                    var $text=$("<div/>").text(this.toast_body.text).appendTo($body);
            }
            
        $toast.show();

        if(this.timeout){
            setTimeout(() => {
                $("#"+this.toast.attr.id+" .btn-close").trigger('click');
            },this.timeout)
        }
    }

    static Success(iParam) {
        new MSToast({
            parent : $(".toast-container"),
            toast : {
                class : "toast ms-auto bg-success",
                attr : {
                    id : iParam.toast.id,
                    role : "alert",
                    "aria-live" : "assertive",
                    "aria-atomic" : true
                }
            },
            header : {
                class : "toast-header",
                img : {
                    src : iParam.header.img.path,
                    class : "bg-light rounded px-1",
                    height : iParam.header.img.height ? iParam.header.img.height : "20px",
                    width : iParam.header.img.width ? iParam.header.img.width : "60px"
                }
            },
            body : {
                class : "toast-body",
                text : iParam.body.text
            },
            timeout: iParam.timeout ? iParam.timeout : 2000 // milliseconds
        }).$create();
    }

    static Info(iParam) {
        new MSToast({
            parent : $(".toast-container"),
            toast : {
                class : "toast w-50 ms-auto bg-info",
                attr : {
                    id : "toast_prog",
                    role : "alert",
                    "aria-live" : "assertive",
                    "aria-atomic" : true
                }
            },
            header : {
                class : "toast-header",
                img : {
                    src : "images/monnaie-services.svg",
                    class : "bg-light rounded px-1",
                    height : "20px",
                    width : "60px"
                }
            },
            body : {
                class : "toast-body",
                text : iParam.body.text
            },
            timeout: iParam.timeout ? iParam.timeout : 2000 // milliseconds
        }).$create();
    }

    static Warning(iParam) {
        new MSToast({
            parent : $(".toast-container"),
            toast : {
                class : "toast w-50 ms-auto bg-warning",
                attr : {
                    id : "toast_prog",
                    role : "alert",
                    "aria-live" : "assertive",
                    "aria-atomic" : true
                }
            },
            header : {
                class : "toast-header",
                img : {
                    src : "images/monnaie-services.svg",
                    class : "bg-light rounded px-1",
                    height : "20px",
                    width : "60px"
                }
            },
            body : {
                class : "toast-body",
                text : iParam.body.text
            },
            timeout: iParam.timeout ? iParam.timeout : 2000 // milliseconds
        }).$create();
    }

    static Error(iParam) {
        new MSToast({
            parent : $(".toast-container"),
            toast : {
                class : "toast w-50 ms-auto bg-danger",
                attr : {
                    id : "toast_prog",
                    role : "alert",
                    "aria-live" : "assertive",
                    "aria-atomic" : true
                }
            },
            header : {
                class : "toast-header",
                img : {
                    src : "images/monnaie-services.svg",
                    class : "bg-light rounded px-1",
                    height : "20px",
                    width : "60px"
                }
            },
            body : {
                class : "toast-body",
                text : iParam.body.text
            },
            timeout: iParam.timeout ? iParam.timeout : 2000 // milliseconds
        }).$create();
    }
}